import React from "react";
import Header from "../components/header/header";
import Psychiatrists from "../../assets/img/doc-img.jpg";
import Therapists from "../../assets/img/doc-img2.jpg";
import Psychologists from "../../assets/img/doc-img3.jpg";
import ProcessOne from "../../assets/img/process1.jpg";
import ProcessTwo from "../../assets/img/process2.jpg";
import ProcessThree from "../../assets/img/process3.jpg";
import IOS from "../../assets/img/ios-btn.png";
import Andriod from "../../assets/img/android-btn.png";
import Twitter from "../../assets/img/twitter-icon.png";
import Insta from "../../assets/img/insta-icon.png";
import LinkedIn from "../../assets/img/linkedin-icon.png";
import YouTube from "../../assets/img/youtube-icon.png";
import Facebook from "../../assets/img/facebook-icon.png"
import LogoCigna from "../../assets/img/logo-cigna.svg";
import LogoHumana from "../../assets/img/logo-humana.png";
import LogoMolina from "../../assets/img/logo-molina.svg";
import LogoUnited from "../../assets/img/logo-united.svg";
import LogoAetna from "../../assets/img/logo-aetna.svg";
import "./home.scss";
const Home = () => {

    function gtag_report_conversion(e, url) {
        var callback = function () {
            if (typeof (url) != 'undefined') {
                window.location = url;
            }
        };
        /* eslint-disable-next-line */
        gtag('event', 'conversion', {
            'send_to': 'AW-11266211333/7oIgCP3s5NUYEIX8kvwp',
            'event_callback': callback
        });
        return false;
    }

    return (
        <div className="home-container">
            <div className="header-component">
                <Header />
                <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="top-banner">
                                <div className="container">
                                    <div className="tb-content">
                                        <h1>
                                            Virtual Care<br />
                                            From Anywhere<br />
                                            Schedule Online Today
                                        </h1>

                                        <a href="https://consumer.scheduling.athena.io/?locationId=20729-1&practitionerId=20729-1" className="button pri-button" style={{ color: '#fff' }} onClick={(e) => gtag_report_conversion(e, "https://consumer.scheduling.athena.io/?locationId=20729-1&practitionerId=20729-1")}>Get Started</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <section className="home-roles">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-12 col-md-6 col-lg-3">
                            <article className="role-card role-card--patient">
                                <span className="role-card-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="8" r="4" />
                                        <path d="M4 21a8 8 0 0 1 16 0" />
                                    </svg>
                                </span>
                                <h3>Member/Patient</h3>
                                <p>Access licensed doctors for personalized mental health care.</p>
                                <div className="role-card-actions">
                                    <a href="https://consumer.scheduling.athena.io/?locationId=20729-1&practitionerId=20729-1" target="_blank" rel="noopener noreferrer" className="role-card-cta">Talk to a doctor</a>
                                    <a href="https://consumer.scheduling.athena.io/?locationId=20729-1&practitionerId=20729-1" target="_blank" rel="noopener noreferrer" className="role-card-link">
                                        Set up account
                                        <svg className="role-card-link-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                            <path d="M5 12h14M13 5l7 7-7 7" />
                                        </svg>
                                    </a>
                                </div>
                            </article>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3">
                            <article className="role-card role-card--provider">
                                <span className="role-card-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M6 3v6a4 4 0 0 0 8 0V3" />
                                        <path d="M5 3h2M13 3h2" />
                                        <path d="M10 13v3a4 4 0 0 0 8 0v-1" />
                                        <circle cx="18" cy="14" r="2" />
                                    </svg>
                                </span>
                                <h3>Doctors/Providers</h3>
                                <p>Join our physician-led telehealth network.</p>
                                <div className="role-card-actions">
                                    <a href="/contact-us" className="role-card-cta">Become a provider</a>
                                    <a href="/contact-us" className="role-card-link">
                                        Let's talk
                                        <svg className="role-card-link-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                            <path d="M5 12h14M13 5l7 7-7 7" />
                                        </svg>
                                    </a>
                                </div>
                            </article>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3">
                            <article className="role-card role-card--facilities">
                                <span className="role-card-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M4 21V8l8-5 8 5v13" />
                                        <path d="M12 11v6M9 14h6" />
                                        <path d="M4 21h16" />
                                    </svg>
                                </span>
                                <h3>Clinics/Facilities</h3>
                                <p>Tell us about your need. Contract for provider hours.</p>
                                <div className="role-card-actions">
                                    <a href="/contact-us" className="role-card-cta">Need a provider</a>
                                    <a href="/contact-us" className="role-card-link">
                                        Request a demo
                                        <svg className="role-card-link-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                            <path d="M5 12h14M13 5l7 7-7 7" />
                                        </svg>
                                    </a>
                                </div>
                            </article>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3">
                            <article className="role-card role-card--business">
                                <span className="role-card-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="7" width="18" height="13" rx="2" />
                                        <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                        <path d="M3 13h18" />
                                    </svg>
                                </span>
                                <h3>Businesses</h3>
                                <p>See how partnering with us can benefit your organization.</p>
                                <div className="role-card-actions">
                                    <a href="/contact-us" className="role-card-cta">Partner with us</a>
                                    <a href="/contact-us" className="role-card-link">
                                        Learn more
                                        <svg className="role-card-link-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                            <path d="M5 12h14M13 5l7 7-7 7" />
                                        </svg>
                                    </a>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </section>

            {/* Insurance strip */}
            <div className="home-insurance-strip">
                <div className="container">
                    <p className="home-insurance-title">We accept most major insurances</p>
                    <div className="home-insurance-logos">
                        <img src={LogoCigna} alt="Cigna" />
                        <img src={LogoHumana} alt="Humana" className="logo-humana" />
                        <img src={LogoMolina} alt="Molina Healthcare" className="logo-molina" />
                        <img src={LogoAetna} alt="Aetna" />
                        <img src={LogoUnited} alt="UnitedHealthcare" className="logo-united" />
                    </div>
                </div>
            </div>

            <div className="doc-banner-bx">
                <div className="doc-banner"> </div>
                <div className="container">
                    <div className="doc-bnr-cntnt col-sm-4">
                        <h1>Our Top Rated<br />Psychiatrists<br />Therapists <br />Psychologists</h1>
                        <p className="doc-banner-text">See Our Trained, Experienced
                            State Licensed Psychiatrists
                            Therapists, Psychologists &
                            Health Care Professionals</p>
                        <a href="#" className="see-more-doc">See These Providers From Your State</a>
                    </div>
                </div>
            </div>
            {/* our psychiatrists */}
            <div className="container doc-tabs">
                <div className="row">
                    <div className="col">
                        <div className="doc-sec">
                            <div className="doc-img"><img src={Psychiatrists} alt="" /></div>
                            <div className="doc-spec">Our Psychiatrists</div>
                            <a href="#" className="doc-link">Read more</a>
                        </div>
                    </div>
                    <div className="col">
                        <div className="doc-sec">
                            <div className="doc-img"><img src={Therapists} alt="" /></div>
                            <div className="doc-spec">Our Therapists </div>

                            <a href="#" className="doc-link">Read more</a>
                        </div>
                    </div>
                    <div className="col">
                        <div className="doc-sec">
                            <div className="doc-img"><img src={Psychologists} alt="" /></div>
                            <div className="doc-spec">Our Psychologists</div>
                            <a href="#" className="doc-link">Read more</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* want to became doctor */}
            <div className="container become-doc">
                <div className="become-doc-txt">Want to become a <strong>VirtualPsych</strong> doctor?</div>
                <a className="button pri-button">Learn More</a>
            </div>
            {/* visits */}
            <div className="app-process">
                <div className="container">
                    <h1>What to expect during your visits</h1>
                    <div className="row">
                        <div className="col">
                            <div className="process-text">
                                Search Provider According to Your Need<br /><br />
                            </div>
                            <img src={ProcessOne} alt="" />
                        </div>
                        <div className="col">
                            <div className="process-text">
                                Select Available Healthcare Provider<br /><br />
                            </div>
                            <img src={ProcessTwo} alt="" />
                        </div>
                        <div className="col">
                            <div className="process-text">
                                Start A Call With a Healthcare Provider<br /><br />
                            </div>
                            <img src={ProcessThree} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            {/* app-banner */}
            <div className="app-bx">
                <div className="app-banner"> </div>
                <div className="container">
                    <div className="app-bnr-cntnt">
                        <h1>Care On The GO</h1>
                        <h4>Download App</h4>
                        <div className="app-download-link">
                            <a href="#"><img src={IOS} alt="" /></a>
                            <a href="#"><img src={Andriod} alt="" /></a>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Footer /> */}
            <footer className="main-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-4">
                            <ul>
                                <li><strong>LEARN MORE</strong></li>
                                <li><a href="#">About VirtualPsych Health</a></li>
                                <li><a href="#">Blog</a></li>
                                <li><a href="https://angel.co/jobs">Careers</a></li>
                                <li><a href="#">Newsroom</a></li>
                            </ul>
                        </div>
                        <div className="col-sm-4">
                            <ul>
                                <li><strong>SOLUTIONS</strong></li>
                                <li><a href="#">VirtualPsych for Businesses</a></li>
                                <li><a href="#">VirtualPsych for Health Systems</a></li>
                            </ul>
                        </div>
                        <div className="col-sm-4">
                            <ul>
                                <li><strong>CONNECT WITH US</strong></li>
                                <li><a href="/contact-us">Contact Us</a></li>
                                <li><a href="/contact-us">Request a Demo</a></li>
                                <li><a href="/contact-us">Become a Provider</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="social-sec">
                    <a href="https://www.facebook.com/VirtualPsychFB/" className="social-icon"><img src={Facebook} alt="" /></a>
                    <a href="#" className="social-icon"><img src={Twitter} alt="" /></a>
                    <a href="#" className="social-icon"><img src={Insta} alt="" /></a>
                    <a href="#" className="social-icon"><img src={LinkedIn} alt="" /></a>
                    <a href="#" className="social-icon"><img src={YouTube} alt="" /></a>
                </div>
            </footer>
            {/* <div className="privacy-sec">
                <div className="container">
                    <a href="#">Privacy Policy</a>
                    <a href="/terms-condition">Terms & Conditions</a>
                    <a href="#">Notice of Non-Discrimination</a>
                </div>
            </div> */}
        </div>
    )
};

export default Home;